import { format } from 'owa-localize';
import { localizedFormatter } from './localizedFormatter';
import { getDayFormat } from './formatDay';
import { getLocalizedString } from 'owa-datetime-formatters-core';
import isOneSpecifierBeforeTheOther from './isOneSpecifierBeforeTheOther';
import type { OwaDate, GlobalCalendarLocale } from 'owa-datetime';

export function getMonthDayFormat(dateFormat: string, timeFormat: string): string {
    const dayFormat = getDayFormat(dateFormat, timeFormat);
    const dayFirst = isOneSpecifierBeforeTheOther(dateFormat, 'd', 'M');
    const formatString = dayFirst
        ? getLocalizedString('monthDayFormatDayFirst')
        : getLocalizedString('monthDayFormatMonthFirst');
    return format(formatString, getLocalizedString('MMMM'), dayFormat);
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string =
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
    localizedFormatter(getMonthDayFormat);
export default defaultExport;
